import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';
import { ICSSProps } from './codeInput.models';

export const ErrorMessage = styled.p`
  position: relative;
  display: flex;
  justify-content: center;
  animation: fadein 2s;
  margin-block: 0;
  margin-inline: 0;
  margin-bottom: -2px !important;
  color: ${theme.colors.brand.primaryHover};
  font-size: ${theme.typography.fontSize.body3};
  line-height: ${theme.typography.lineHeight.body3};
  font-family: ${theme.typography.fontFamily.secondary};
  text-align: center;

  @keyframes fadein {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  ${media.desktop`
    margin-bottom: -${theme.spacing.sm} !important;
  `}
`;
export const FieldsetContainer = styled.div`
  display: flex;
  justify-content: center;
`;
export const Fieldset = styled.div<ICSSProps>`
  width: 500px;
  height: 57px;
  position: relative;
  margin: 0;
  padding-top: ${theme.spacing.md}
  padding-bottom:  ${theme.spacing.md}
  display: flex;
  transition: border 2s;
  background: transparent;
  ${(props) => {
    return props.isDisabled
      ? `border-bottom: 1px solid ${theme.colors.border.default}`
      : `border-bottom: 1px solid ${theme.colors.border.default}`;
  }};

  .wrapper {
    display: flex;
    justify-content: center;
    width: 100%;
    margin: 0;
    padding: 0;
    height: ${theme.spacing.lg};
  }

  ${(props) => (props.isDisabled ? '&:hover {cursor: not-allowed}' : '')}
`;

// div for inputs
export const Field = styled.input<ICSSProps>`
  background-color: transparent;
  margin: auto;
  padding: 0;
  width: 100%;
  height: 27px;
  outline: 0;
  border: 0;
  text-overflow: ellipsis;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h5}
  text-align: center;

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${theme.colors.text.primary};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }

  ${media.tablet`
    margin: auto;
  `}
`;

